import classnames from 'classnames';
import React from 'react';

import { Grid, GridColumn } from '@/design-system/atoms/Grid';
import { Loading } from '@/design-system/atoms/Loading';

import { SearchResultPlaceholder } from '../SearchResultPlaceholder';
import styles from './SearchLoading.module.scss';

const PLACEHOLDER_ITEMS = 2;

/**
 * The SearchLoading component displays an animation while loading search results.
 * @param {object} props - The component props
 * @param {string} props.className - Additional class name
 * @returns {React.Component} The search loading animation component
 */
const SearchLoading = ({ className, ...props }) => {
    return (
        <Grid className={classnames(styles['search-loading'], className)} {...props}>
            <div className={styles['search-loading__background']} />
            <div className={styles['search-loading__content']}>
                <Loading />
            </div>
            <GridColumn
                className={styles['search-loading__placeholder']}
                colSpan={{ sm: 4, md: 6, lg: 9 }}
                colStart={{ sm: 1 }}
            >
                {Array.from({ length: PLACEHOLDER_ITEMS }).map((_, index) => (
                    <SearchResultPlaceholder key={index} />
                ))}
            </GridColumn>
        </Grid>
    );
};

export default SearchLoading;
